// - In Figma: Prefix all color variables with 'color-' and replace underscores with hyphens
//  - In Code: Use camelCase with underscores
//  - Example:
//    - Code: brand_primary -> Figma: color-brand-primary
//    - Code: semantic_error -> Figma: color-semantic-error

import colorsV1 from './v1'

export const brand = {
  brand_primary: '#E960AF',
  brand_secondary: '#FF85CB',
} as const

export const foreground = {
  fg_highlight: brand.brand_primary,
  fg_primary: '#fff',
  fg_secondary: 'rgba(255,255,255,.72)',
  fg_tertiary: 'rgba(255,255,255,.56)',
  fg_disabled: 'rgba(255,255,255,.42)',
  fg_link: 'rgba(138,180,255,1)',
} as const

export const background = {
  bg_primary: '#16191F',
  bg_secondary: '#1E212A',
  bg_overlay: 'rgba(255,255,255,.16)',
  bg_surface_primary_1: brand.brand_primary,
  bg_surface_primary_2: brand.brand_secondary,
  bg_surface_secondary: 'rgba(255,255,255,.12)',
  bg_surface_tertiary: 'rgba(255,255,255,.06)',
} as const

export const stroke = {
  stroke_base: 'rgba(255,255,255,.16)',
  stroke_hovering: 'rgba(255,255,255,.32)',
  stroke_active: 'rgba(255,255,255,1)',
} as const

export const semantic = {
  semantic_success: '#06C270',
  semantic_info: '#49a1b8',
  semantic_error: '#ED6A5E',
  semantic_warning: '#F3BF4F',
  semantic_featured: '#00FFEA',
} as const

export const accent = {
  accent_yellow_1: 'rgba(225,209,11,1)',
  accent_yellow_2: 'rgba(225,209,11,0)',
  accent_gold_1: 'rgba(247,244,207,1)',
  accent_gold_2: 'rgba(240,126,0,1)',
  accent_silver_1: 'rgba(220,229,232,1)',
  accent_silver_2: 'rgba(85,120,134,1)',
  accent_bronze_1: 'rgba(209,166,110,1)',
  accent_bronze_2: 'rgba(140,69,0,1)',
} as const

export const email = {
  email_fg_highlight: brand.brand_primary,
  email_fg_primary: '#17191F',
  email_bg_primary: '#FEF6FA',
  email_bg_secondary: '#FFF',
} as const

const colors = {
  ...brand,
  ...foreground,
  ...background,
  ...semantic,
  ...email,
  ...accent,
  ...stroke,

  // Old version
  ...colorsV1,
} as const

export type ColorKey = keyof typeof colors
export default colors
